// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__MnoK6","label":"Section_label__2mn86","contentWrap":"Section_contentWrap__25JE6","footer":"Section_footer__17leE","footerInner":"Section_footerInner__2f9Jq"};